import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const TopNav = ({ setSidebarOpen, onCreatePost }) => {
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleSettings = () => {
    navigate('/settings');
  };

  const handleCreatePost = () => {
    if (onCreatePost) onCreatePost();
  };

  const handleNotifications = () => {
    // Notifications will be wired to real data later
  };

  const handleProfile = () => {
    navigate('/settings');
  };

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="flex items-center justify-between h-16 px-4 lg:px-6">
        {/* Left side - Mobile menu button */}
        <div className="flex items-center">
          <button
            type="button"
            className="inline-flex items-center justify-center p-2 rounded-xl text-gray-400 hover:text-gray-500 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-accent-300 lg:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <i className="fas fa-bars h-6 w-6"></i>
          </button>

          {/* Breadcrumb or page title could go here */}
          <div className="hidden lg:block ml-4">
            <h2 className="text-lg font-semibold font-heading text-gray-900">
              Welcome back, {user?.first_name || user?.username || 'User'}!
            </h2>
          </div>
        </div>

        {/* Right side - Actions and profile */}
        <div className="flex items-center space-x-4">
          {/* Create Post Button */}
          <button
            onClick={handleCreatePost}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-xl text-accent-900 bg-accent-600 hover:bg-accent-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent-300 transition-colors duration-150"
          >
            <i className="fas fa-plus mr-2"></i>
            Create Post
          </button>

          {/* Notifications */}
          <button
            onClick={handleNotifications}
            className="p-2 text-gray-400 hover:text-gray-500 hover:bg-gray-50 rounded-xl transition-colors duration-150"
          >
            <span className="sr-only">View notifications</span>
            <i className="fas fa-bell h-5 w-5"></i>
          </button>

          {/* Profile dropdown */}
          <div className="relative">
            <button
              type="button"
              className="flex items-center max-w-xs bg-white rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent-300"
              onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}
            >
              <span className="sr-only">Open user menu</span>
              <img
                className="h-8 w-8 rounded-full"
                src={`https://ui-avatars.com/api/?name=${encodeURIComponent(user?.first_name || user?.username || 'User')}&background=6b7280&color=fff`}
                alt="User avatar"
              />
              <i className="fas fa-chevron-down ml-2 text-gray-400 text-xs"></i>
            </button>

            {/* Dropdown menu */}
            {profileDropdownOpen && (
              <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-xl bg-white border border-gray-200 z-50">
                <div className="py-1">
                  <div className="px-4 py-2 text-sm text-gray-700 border-b border-gray-100">
                    <p className="font-medium">{user?.first_name && user?.last_name ? `${user.first_name} ${user.last_name}` : user?.username}</p>
                    <p className="text-gray-500">{user?.email}</p>
                  </div>
                  <button
                    type="button"
                    onClick={handleProfile}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                  >
                    <i className="fas fa-user mr-2"></i>
                    Your Profile
                  </button>
                  <button
                    type="button"
                    onClick={handleSettings}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                  >
                    <i className="fas fa-cog mr-2"></i>
                    Settings
                  </button>
                  <button
                    type="button"
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                  >
                    <i className="fas fa-sign-out-alt mr-2"></i>
                    Sign out
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopNav;
